import React, { useEffect } from 'react';
import LoaderSpin from '../components/atoms/LoaderSpin';
import { useNavigate, useParams } from 'react-router-dom';
import { useLeaveMeetingMutation } from '../store/services/disputeService';

function LeaveMeeting() {
  const { disputeId } = useParams();
  const [LeaveMeeting] = useLeaveMeetingMutation();
  const navigate = useNavigate();

  const handleLeaveMeeting = async () => {
    try {
      await LeaveMeeting({ disputeId })?.unwrap();
      navigate('/dispute');
    } catch (err) {
      console.log(err);
      navigate('/dispute');
    }
  };
  useEffect(() => {
    if (disputeId) {
      handleLeaveMeeting();
    }
  }, [disputeId]);
  return <LoaderSpin />;
}

export default LeaveMeeting;
